import React from 'react'

import {
  TemplatePage,
  Grid,
  Span,
} from 'components'
import LogoCSN from 'assets/images/logo_csn_horizontal.png'
import { SPACING } from 'utils'

const NotFoundPage: React.FC = () => {
  return (
    <Grid
      margin={`${SPACING.spacing100} ${SPACING.spacing30}`}
      alignItems="center"
      justifyItems="center"
    >
      <img src={LogoCSN} width={200} />
      <Span fontSize={'1.3rem'} text="Página não encontrada" />
    </Grid>
  )
}

const NotFound: React.FC = () => {
  return (
    <TemplatePage hideMenus={false} page={<NotFoundPage />} title="404" />
  )
}

export default NotFound
